/* eslint-disable react/no-danger */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useMemo, useState } from 'react';
import { Button, Col, Input, Row, Label } from 'reactstrap';
import { TOOLTIPS_TEXT } from '../../../../../../../lib/constants';
import ConfirmationModal from '../../../../../../ConfirmationModal';
import CustomModal from '../../../../../../CustomModal';
import InfoPopup from '../../../../../../InfoPopup';
import SpinnerCircles from '../../../../../../Spinner/SpinerCircles';
import { BUTTON_TEXT, MODAL_BODY_TEXT } from '../../constants';
import { useResetToDefault } from '../../hooks';
import './index.css';
import { getPermissionForComponent } from '../../../../../../../utils/permissionsUtils';

/* Sub Components */
const ModalWithInput = ({ bodyText, handleChange }) => {
  const normalizedBodyText = useMemo(() => {
    let data = bodyText;
    if (bodyText.includes('Default')) {
      data = bodyText.replace('Default', '<b>Default</b>');
    }
    return data;
  }, []);

  const sanitizeData = () => {
    return {
      __html: normalizedBodyText,
    };
  };
  return (
    <div className="wrapper reset-modal">
      <Row>
        <Col lg={7} md={7} sm={4}>
          <p style={{ whiteSpace: 'nowrap' }} dangerouslySetInnerHTML={sanitizeData()} />
        </Col>
        <Col lg={5} md={5} sm={4}>
          <Input required type="text" name="validation" placeHolder='Default' onChange={handleChange} style={{ border: '1px solid lightgray' }} autoFocus={true} />
        </Col>
      </Row>
    </div>
  );
};

const ModalWithNotesInput = ({ bodyText }) => {
  return (
    <Row>
      <p>{bodyText}</p>
    </Row>
  );
};

/* Component */
export const ResetBoxToDefault = ({ loading, setDcUpdatePopup,box ,user}) => {
  const [resetBoxResult, setResetBoxResult] = useState(null);

  const {
    handlerState,
    isModalTypeOnStepTwo,
    onWarningModalConfirm,
    handleResetInputChange,
    showStepOneWarningModal,
    hideAndResetWarningModalToDefaultType,
    changeBoxOptionsAndRefreshBox,
  } = useResetToDefault({ setResetBoxResult });
  const resetToDefault = getPermissionForComponent('resetToDefault',user?.permissionsGroup);
  const canExecuteReset = resetToDefault === 'write' || resetToDefault === 'both';

  const { showWarningModalForReset } = handlerState;

  const shouldComponentBeSentAsProp = useCallback(() => {
    if (!isModalTypeOnStepTwo)
      return <ModalWithNotesInput bodyText={MODAL_BODY_TEXT.DEFAULT} />;
    return (
      <ModalWithInput bodyText={MODAL_BODY_TEXT.SECODARY} handleChange={handleResetInputChange} />
    );
  }, [isModalTypeOnStepTwo, handleResetInputChange]);

  return (
    <div className="modam-row mt-2 mb-2 mr-1">
      {canExecuteReset && (
        <>
          <h1 className="heading d-flex">
            Reset To Default
            <sup>
              <InfoPopup id="resettodefault" text={TOOLTIPS_TEXT.RESET_BOX_TO_DEFAULT} />
            </sup>
          </h1>
          <Button
            disabled={loading}
            onClick={() => {
              const divElement = document.getElementById('test-time-remaining');
              const isHidden = divElement.getAttribute('hidden') !== null;
              if (isHidden) {
                setDcUpdatePopup({ show: true });
              } else {
                showStepOneWarningModal()
              }

            }}
            color="danger"
            className="admin-tool-execute-btn"
          >
            {loading ? <SpinnerCircles /> : BUTTON_TEXT.EXECUTE}
          </Button>
        </>
      )}
      {/* Confirmation Modal */}
      {showWarningModalForReset && (
        <ConfirmationModal
          customBodyComponent={shouldComponentBeSentAsProp()}
          resetBoxComponent
          confirmBtnText={isModalTypeOnStepTwo ? BUTTON_TEXT.GO : BUTTON_TEXT.EXECUTE}
          isOpen={showWarningModalForReset}
          onCancel={hideAndResetWarningModalToDefaultType}
          onConfirm={onWarningModalConfirm}
          warning={showWarningModalForReset}
        />
      )}


      {/* Result Modal */}
      {resetBoxResult && (
        <CustomModal
          isOpen={!!resetBoxResult}
          header="Reset Box Result"
          showCustomButton
          customButtonText="OK"
          onCancel={changeBoxOptionsAndRefreshBox}
        >
          <Label className="font-weight-bold">Success Reset Logs</Label>
          <ul className="success-logs-items">
            {resetBoxResult?.success &&
              resetBoxResult?.success.map((action, idx) => {
                return (
                  <li key={idx}>
                    <FontAwesomeIcon
                      icon="check"
                      size="lg"
                      color="#198754"
                      style={{ marginRight: '1rem' }}
                    />
                    {action}
                  </li>
                );
              })}
          </ul>

          <Label className="font-weight-bold">Failed Reset Logs</Label>
          <ul className="error-logs-items">
            {resetBoxResult?.error &&
              resetBoxResult?.error.map((action, idx) => {
                return (
                  <li key={idx}>
                    <FontAwesomeIcon
                      icon="times"
                      size="lg"
                      color="#dc3545"
                      style={{ marginRight: '1rem' }}
                    />
                    {action}
                  </li>
                );
              })}
          </ul>
        </CustomModal>
      )}
    </div>
  );
};
